// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-83c147f4] .table-tit {\n  font-weight: 1000;\n  font-size: 16px;\n  color: #000;\n  height: 40px;\n}\n.table-ove[data-v-83c147f4] {\n  margin-bottom: 20px;\n}\n.Overview[data-v-83c147f4] {\n  padding: 0 10px;\n}\n[data-v-83c147f4] .el-table__body-wrapper .el-table__cell {\n  font-size: 14px;\n}\n[data-v-83c147f4] .level1 {\n  font-size: 14px;\n  color: #000;\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
